import React from 'react';

export const ChatHistoryIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="7 9 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.75 15.6504C13.2194 15.6504 13.5996 16.0306 13.5996 16.5C13.5996 16.9694 13.2194 17.3496 12.75 17.3496H11.25C10.7806 17.3496 10.4004 16.9694 10.4004 16.5C10.4004 16.0306 10.7806 15.6504 11.25 15.6504H12.75Z"
      fill="currentColor"
    />
    <path
      d="M12.75 13.1504C13.2194 13.1504 13.5996 13.5306 13.5996 14C13.5996 14.4694 13.2194 14.8496 12.75 14.8496H11.25C10.7806 14.8496 10.4004 14.4694 10.4004 14C10.4004 13.5306 10.7806 13.1504 11.25 13.1504H12.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 10C22.6569 10 24 11.3431 24 13V19C24 20.6569 22.6569 22 21 22H11L10.8457 21.9961C9.26055 21.9158 8 20.6051 8 19V13C8 11.3431 9.34315 10 11 10H21ZM11 11.7002C10.282 11.7002 9.7002 12.282 9.7002 13V19C9.7002 19.718 10.282 20.2998 11 20.2998H14.1504V11.7002H11ZM15.8496 20.2998H21C21.718 20.2998 22.2998 19.718 22.2998 19V13C22.2998 12.282 21.718 11.7002 21 11.7002H15.8496V20.2998Z"
      fill="currentColor"
    />
  </svg>
);
